var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { Availability } from "../Availability";
import { ScheduleAvailabilityService, SectionVisibilityService, } from "../Menu";
import { ProductTypePreorderSettingsService } from "../PreorderSettingsService";
let ProductTypeAvailabilityService = class ProductTypeAvailabilityService {
    constructor(productTypePreorderSettingsService, sectionVisibilityService, scheduleAvailabilityService) {
        this.productTypePreorderSettingsService = productTypePreorderSettingsService;
        this.sectionVisibilityService = sectionVisibilityService;
        this.scheduleAvailabilityService = scheduleAvailabilityService;
        makeImmutable(this);
    }
    productTypeAvailability(productType, parameterSet, fulfillmentTime) {
        return [
            Availability.dependent("ProductType", "", this.basicAvailability(productType, parameterSet)),
            Availability.dependent("ProductTypeTimeBased", "", this.timeBasedAvailability(productType, fulfillmentTime)),
        ];
    }
    visibilityAvailability(productType) {
        const isVisible = productType.groups.objects.some((productTypeGroup) => this.sectionVisibilityService.isSectionVisible(productTypeGroup.visibilityScheduleId));
        return isVisible
            ? Availability.available()
            : Availability.unavailable("Visibility");
    }
    basicAvailability(productType, parameterSet) {
        const { availabilitySpec, pricing } = productType;
        if (availabilitySpec.type === "TemporarilyUnavailable") {
            return Availability.unavailable("TemporarilyUnavailable");
        }
        const parametric = Availability.parametrized({
            unavailabilityReason: "ParametrizedAvailability",
            parametrization: availabilitySpec.availabilityParametrization,
            parameterSet,
        });
        const price = Availability.parametrized({
            unavailabilityReason: "PriceAvailability",
            parametrization: pricing.map(() => true),
            parameterSet,
        });
        const visibility = this.visibilityAvailability(productType);
        return Availability.composite([parametric, price, visibility]);
    }
    timeBasedAvailability(productType, fulfillmentTime) {
        const { availabilitySpec } = productType;
        if (availabilitySpec.type === "TemporarilyUnavailable") {
            return Availability.unavailable("TemporarilyUnavailable");
        }
        const schedule = availabilitySpec.availabilitySchedule === null
            ? Availability.available()
            : Availability.schedule({
                availabilitySchedule: availabilitySpec.availabilitySchedule,
                fulfillmentTime,
                scheduleAvailabilityService: this.scheduleAvailabilityService,
            });
        const preorder = Availability.preorder({
            fulfillmentTime,
            preorderSettings: this.productTypePreorderSettingsService.preorderSettings(productType),
        });
        return Availability.composite([schedule, preorder]);
    }
};
ProductTypeAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductTypePreorderSettingsService !== "undefined" && ProductTypePreorderSettingsService) === "function" ? _a : Object, typeof (_b = typeof SectionVisibilityService !== "undefined" && SectionVisibilityService) === "function" ? _b : Object, typeof (_c = typeof ScheduleAvailabilityService !== "undefined" && ScheduleAvailabilityService) === "function" ? _c : Object])
], ProductTypeAvailabilityService);
export { ProductTypeAvailabilityService };
